<template>
    <div class="loginh5">
        <img src="@/assets/img/h5/img_pc.png" alt="">
        <p>请使用PC打开此链接，手机暂不支持。</p>
    </div>
</template>
<script>

export default {
    created() {
    },
    data() {
        return {

        }
    },
    methods: {

    },
    components: {}
};
</script>
<style lang="scss" scoped>
.loginh5 {
    width: 100%;
    height: 100%;
    background-color: #F0F1F2;
    text-align: center;
    position: relative;

    img {
        width: 222px;
        height: 222px;
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    p {
        width: 324px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #666666;
        line-height: 40px;
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>